var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./QRCode.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-61ab0537\"}!../../vue-loader/lib/selector?type=template&index=0!./QRCode.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports
